module.exports = __webpack_public_path__ + "static/cornbread-poster-8cc09136d74f375c5be74f9ff745eac4.jpg";